/* eslint-disable */
import 'whatwg-fetch';
//import { browserHistory } from 'react-router';
import { inferUserLanguage } from "../i18n";
import { camelizeKeys, decamelizeKeys } from 'humps';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

const { REACT_APP_API_BASE_URL, REACT_APP_API_ROOT } = process.env;
import { getAccessToken, getLanguage, isAccessTokenExpired } from 'utils/helpers';


function getUrl(endpoint, options, isLogger) {
  let url;
  if (isLogger) {
    url = endpoint;
  } else {
    url = `${REACT_APP_API_BASE_URL}${endpoint}`;
  }
  const qs = queryString.stringify(decamelizeKeys(get(options, 'params', {})));
  if (qs) {
    url += `?${qs}`;
  }
  return url;
}

function getHeaders(options, useFormEncoded, isLogger) {
  const headers = {};
  if (isLogger) {
    return headers;
  }
  const token = getAccessToken();
  if (token && !isAccessTokenExpired(token)) {
    headers.Authorization = `Bearer ${token.accessToken}`;
  }
  // TODO necessary?
  headers.Accept = 'application/json';

  const languageSelected = inferUserLanguage();
  if (languageSelected) {
    headers['Accept-Language'] = languageSelected;
  }

  // WORKAROUND oauth calls work with form urlencoded
  if (useFormEncoded) {
    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
  } else if (!/get|delete/i.test(get(options, 'method', 'get'))) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
}

function getBody(options, useFormEncoded, isLogger) {
  const body = get(options, 'body');
  if (isEmpty(body)) {
    return;
  }
  if (useFormEncoded) {
    return queryString.stringify(decamelizeKeys(body));
  }
  if (isLogger) {
    return JSON.stringify(body);
  }
  return JSON.stringify(decamelizeKeys(body));
}


function handleResponse(response) {
  let contentType = response.headers.get('content-type');
  if (contentType.includes('application/json') || contentType.includes('application/problem+json')) {
    return handleJSONResponse(response)
  } else if (contentType.includes('text/html')) {
    return handleTextResponse(response)
  } else {
    // Other response types as necessary. I haven't found a need for them yet though.
    throw new Error(`Sorry, content-type ${contentType} not supported`)
  }
}
function handleBlobResponse(response) {

  return response.blob()
    .then(blob => {
      if (response.ok) {
        return blob
      } else {
        return Promise.reject(Object.assign({}, blob, {
          status: response.status,
          statusText: response.statusText,
        }))
      }
    })
}
function handleJSONResponse(response) {

  return response.json()
    .then(json => {
      if (response.ok) {
        return json
      } else {
        return Promise.reject(Object.assign({}, json, {
          status: response.status,
          statusText: "SERVER ERROR: " + (json.detail || json.error || response.statusText),
          url: response.url,
        }))
      }
    })
}
function handleTextResponse(response) {

  return response.text()
    .then(text => {
      if (response.ok) {
        return text
      } else {
        return Promise.reject(Object.assign({}, text, {
          status: response.status,
          statusText: "SERVER ERROR: " + (text.detail || text.error || response.statusText),
          url: response.url,
          err: text
        }))
      }
    })
}



/**
 * Requests a URL, returning a promise
 *
 * @param  {string} endpoint  The endpoint we want to request
 * @param  {object} [defaults] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(endpoint, defaults, isLogger = false) {
  const useFormEncoded = /oauth/i.test(endpoint);
  const url = getUrl(endpoint, defaults, isLogger);
  const headers = getHeaders(defaults, useFormEncoded, isLogger);
  const body = getBody(defaults, useFormEncoded, isLogger);

  const options = {
    ...defaults,
    headers,
    body,
  };

  return fetch(url, options)
    .then(handleResponse)
    .then(data => { /*console.log('request data:', data);*/ return camelizeKeys(data); })
    .catch(error => {
      if (error.status !== 401) {
        throw error;
      }
      console.log('request catch:', error);
    });

}

export function requestImage(endpoint, defaults, isLogger = false) {
  const url = `${REACT_APP_API_ROOT}${endpoint}`;
  const headers = getHeaders(defaults, false, isLogger);

  const options = {
    ...defaults,
    headers,
  };

  return fetch(url, options)
    .then(handleBlobResponse)
    .then(object => URL.createObjectURL(object))
    .catch(error => {
      if (error.status === 404) {
        return false;
      }
      console.log('requestImage catch:', error);
    });


}
